import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import clsx from 'clsx';
import Header from 'components/Header/Header';
import ContactForm from './ContactForm';
import Banner from 'components/Banner/Banner';
import Template from 'components/Template/Template';
import i18n from 'helpers/i18n';
import { getCurrentUserRole } from 'components/UI/Account/ducks/authentication';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Footer from '../Footer';
import Immutable from 'immutable';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

const styles = (theme) => {
  return {
    root: {
      // minHeight: '1024px',
      // height: '100%',
      width: '100%',
      '& .MuiTypography-h3': {
        color: '#fff',
      },
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
    },
    pageTitle: {
      paddingTop: 16,
      // paddingBottom: 16,
      // color: theme.palette.primary.main,
      // textAlign: 'center',
      // fontSize: '2.2rem',
      // backgroundColor: '#fff',
      // marginTop: theme.spacing(2),
      // marginBottom: theme.spacing(2),
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // boxShadow: theme.shadows[3],
      // [theme.breakpoints.down('md')]: {
      //   fontSize: '1.8rem',
      // },
      // [theme.breakpoints.down('sm')]: {
      //   fontSize: '1.5rem',
      // },
      // [theme.breakpoints.down('xs')]: {
      //   fontSize: '1.3rem',
      // },
    },

    // whiteBg: {
    //   position: 'relative',
    //   marginBottom: theme.spacing(4),
    //   '&:before': {
    //     position: 'absolute',
    //     left: 0,
    //     top: 0,
    //     content: "' '",
    //     width: '100%',
    //     height: '100%',
    //     backgroundColor: theme.palette.background.paper,
    //     opacity: 0.9,
    //   },
    // },

    paperWrapper: {
      width: '100%',
      display: 'block',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        content: "' '",
        // height: '160px',
        height: '230px',
        backgroundColor: theme.palette.primary.light,
        backgroundImage: 'url('+require('assets/images/header_contact.jpg')+')',
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat',
        zIndex: -1
      },
      '& .MuiTypography-h1':{
        color:'#fff',
        fontSize:'3rem',
        fontWeight:'bold',
        height:'230px',
        paddingTop:'85px',
        marginBottom: 0,
        marginTop: 0,
      },
      '& .HomeHelpContainer':{
        display:'none',
      },
    },  
    paper: {
      padding: theme.spacing(4),
      position: 'relative',
      maxWidth:'700px',
      margin:'0 auto',
      backgroundColor: 'transparent',
      '& a': {
        color: 'inherit'
      },
      '& .MuiTypography-body1':{
        marginBottom:'2em',
        fontSize:'90%',
      },
    },
    header: {
      height: 150,
      [theme.breakpoints.down('sm')]: {
        height: 150,
      },
    },
    content: {
      // height: 'calc(100% - 150px - 120px)',
      minHeight: '620px',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    footer: {
      height: 120,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
  };
};

class Contact extends Component {
  render() {
    const { onPanelToggle, classes, userRole } = this.props;
    const uri = queryString.parse(window.location.search);
    const $$initValues = uri.s && uri.s === '3' ? Immutable.fromJS({ subject: 'rpps' }) : undefined;
    return (
      <Template current={'contact'} headerImage="background" kind={'fullWidth'} maxWidth={'auto'} resize={true}>
        <Fade in timeout={1000} style={{ width: '100%' }}>
          <div className={classes.root}>
            <Box className={clsx(classes.paperWrapper)}>
            <Typography variant="h1" className={classes.pageTitle}>
              {i18n.get('contactFormTitle')}
            </Typography>{' '}
              <Paper square elevation={0} className={classes.paper}>
                <Typography variant="body1" align="left" gutterBottom>Les informations recueillies ci-dessous sont utilisées dans le cadre de votre demande et pour le suivi des correspondances.<br />Consultez notre <Link to={'/confidentiality'}>Politique de protection des données</Link> pour en savoir plus sur le traitement de vos données et sur vos droits. </Typography>
                <ContactForm userRole={userRole} initValues={$$initValues} formNotice={<Typography variant="body1" align="left">Vous souhaitez avoir des informations concernant l'un de nos produits ou notifier un effet indésirable ? <a href="https://www.biocodex.com/fr/contactez-nous/" target="_blank  ">Ecrivez-nous</a></Typography>}/>

              </Paper>
            </Box>
          </div>
        </Fade>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    userRole: getCurrentUserRole(state),
  };
  return props;
}

export default withStyles(styles)(connect(mapStateToProps)(Contact));



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.jsx